import { render, staticRenderFns } from "./promoBank.vue?vue&type=template&id=03e694f4"
import script from "./promoBank.vue?vue&type=script&lang=js"
export * from "./promoBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports